module.exports = __webpack_public_path__ + "media/images/signatures/2024/kamil-74ec3e8dce1961a56972b583218398ea.png";